module.exports = __webpack_public_path__ + "img/ball_2_orange.5701b146.png";